// Common Thai occupations — used as suggestions for the อาชีพ field (datalist,
// so staff can still type a custom value). Ordered roughly by frequency in a
// dental-clinic patient base.
export const OCCUPATIONS = [
  'นักเรียน / นักศึกษา',
  'พนักงานบริษัทเอกชน',
  'ข้าราชการ',
  'พนักงานรัฐวิสาหกิจ',
  'พนักงานราชการ',
  'ธุรกิจส่วนตัว / เจ้าของกิจการ',
  'ค้าขาย',
  'รับจ้างทั่วไป',
  'ฟรีแลนซ์ / อาชีพอิสระ',
  'เกษตรกร',
  'แม่บ้าน / พ่อบ้าน',
  'ครู / อาจารย์',
  'แพทย์ / พยาบาล / บุคลากรทางการแพทย์',
  'วิศวกร',
  'สถาปนิก',
  'ทนายความ',
  'นักบัญชี',
  'ตำรวจ',
  'ทหาร',
  'พนักงานขับรถ',
  'พนักงานบริการ',
  'โปรแกรมเมอร์ / ไอที',
  'ช่าง / ช่างเทคนิค',
  'พระ / นักบวช',
  'เกษียณอายุ / บำนาญ',
  'ว่างงาน',
  'อื่นๆ',
]
